import { render, staticRenderFns } from "./GiftPlans.vue?vue&type=template&id=6708f86e&scoped=true&"
import script from "./GiftPlans.vue?vue&type=script&lang=ts&"
export * from "./GiftPlans.vue?vue&type=script&lang=ts&"
import style0 from "./GiftPlans.vue?vue&type=style&index=0&id=6708f86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708f86e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6708f86e', component.options)
    } else {
      api.reload('6708f86e', component.options)
    }
    module.hot.accept("./GiftPlans.vue?vue&type=template&id=6708f86e&scoped=true&", function () {
      api.rerender('6708f86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/gifts/paywall/GiftPlans.vue"
export default component.exports